import { useMutation, useQuery } from 'react-query'
import { api } from '../../utils/api'
import { CouponDetail } from './coupon-typed'

export const COUPON_URL = '/app/coupon'

export const GET_COUPON_LIST = `${COUPON_URL}/getCouponList`
export const GET_COUPON = `${COUPON_URL}/getCoupon`
export const GET_COUPON_COLLECTED = `${COUPON_URL}/getCouponCollected`
export const COLLECT_COUPON = `${COUPON_URL}/collectCoupon`

export const useGetCouponList = () => {
  return useQuery<CouponDetail[]>(GET_COUPON_LIST, () =>
    api.belive.get<CouponDetail[]>(GET_COUPON_LIST),
  )
}

export const useGetCouponById = (couponId: number) => {
  return useQuery<CouponDetail>(`${GET_COUPON}/${couponId}`, () =>
    api.belive.get<CouponDetail>(`${GET_COUPON}/${couponId}`),
  )
}

export const useCollectCoupon = () => {
  return useMutation(
    (couponId: number) => {
      return api.belive.post(`${COLLECT_COUPON}/${couponId}`)
    },
    {
      onSuccess: (data) => {
        console.log(data)
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useGetCouponCollected = () => {
  return useQuery<CouponDetail[]>(GET_COUPON_COLLECTED, () =>
    api.belive.get<CouponDetail[]>(GET_COUPON_COLLECTED),
  )
}
